const QUESTIONS_PER_MINUTE = 3;
const MIN_MINUTES = 1;
const EXACT_MAX_MINUTES = 5;
const BUCKET_MAX_MINUTES = 10;

export const formatSetupTimeEstimate = (remainingQuestions: number): string => {
  const minutes = Math.max(
    MIN_MINUTES,
    Math.ceil(remainingQuestions / QUESTIONS_PER_MINUTE)
  );

  if (minutes <= EXACT_MAX_MINUTES) return `~${minutes} min`;
  if (minutes <= BUCKET_MAX_MINUTES) return `~${BUCKET_MAX_MINUTES} min`;

  return `~${BUCKET_MAX_MINUTES}+ min`;
};
